import { getDiscountAmount } from "./pricing";

export const courseUrlFields = [
  ["practiceUrl", "Practice URL"],
  ["reviewMyMistakesUrl", "Review My Mistakes URL"],
  ["myPerformanceUrl", "My Performance URL"],
];

export const validateCourseUrls = (values) => {
  const errors = {};
  for (const [key, label] of courseUrlFields) {
    const value = values[key]?.trim();
    if (!value) continue;
    try {
      const url = new URL(value);
      if (!["http:", "https:"].includes(url.protocol)) throw new Error();
    } catch {
      errors[key] = `${label} must be a valid http or https URL.`;
    }
  }
  return errors;
};

export const buildCourseCreatePayload = (draft, imageUrl) => ({
  name: draft.courseName.trim(),
  academicLevelId: Number(draft.courseGrade),
  price: Number(draft.coursePrice),
  imageUrl: imageUrl || "",
  storeId: Number(draft.courseStore),
  folderId: Number(draft.courseSubfolder || draft.courseFolder),
  discountAmount: Number(draft.discountPercentage) > 0 ? null : Number(draft.courseDiscountAmount) || null,
  discountPercentage: Number(draft.discountPercentage) || null,
  ...Object.fromEntries(courseUrlFields.map(([key]) => [key, draft[key]?.trim() || ""])),
});

// PUT is a full replacement. Always retain fields that this editor does not change.
export const buildCourseUpdatePayload = (course, changes = {}) => ({
  name: course.name,
  academicLevelId: course.academicLevelId ?? null,
  price: Number(course.price),
  imageUrl: course.imageUrl ?? null,
  storeId: course.storeId,
  folderId: course.folderId ?? null,
  discountAmount: getDiscountAmount(course) || null,
  discountPercentage: null,
  ...Object.fromEntries(courseUrlFields.map(([key]) => [key, course[key] ?? null])),
  ...changes,
});
